import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-funding-pending',
  templateUrl: './funding-pending.component.html',
  styleUrls: ['./funding-pending.component.css']
})
export class FundingPendingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
